import { SectionCard } from "#src/commonV2/SectionCard";
import { ReactNode } from "react";

export const EndpointOverviewTableWrapper = ({
  title,
  description,
  table,
}: {
  title: string;
  description: string;
  table: ReactNode;
}) => {
  return (
    <SectionCard
      header={
        <>
          <span className="text-lg font-semibold text-gray-v2-900">
            {title}
          </span>
          <span className="text-md text-gray-v2-600">{description}</span>
        </>
      }
    >
      {table}
    </SectionCard>
  );
};
